import type { ErrorResponse } from '@/shared/api'

import { apiInstance, postRequest } from '@/shared/api'

import type { CreateSbpSubscriptionResponse, UserData } from './types'

import { CHANGE_STATUS_SUBSCRIPTION, CREATE_SBP_SUBSCRIPTION, GET_USER_DATA } from './constants'

export function changeStatusSubscription(methodId: number, status: boolean) {
    return postRequest<unknown, ErrorResponse>(`${CHANGE_STATUS_SUBSCRIPTION}`, {
        payment_method_id: methodId,
        status,
    })
}

export function createSbpSubscription() {
    return postRequest<CreateSbpSubscriptionResponse, ErrorResponse>(
        `${CREATE_SBP_SUBSCRIPTION}`,
        {}
    )
}

export function getUserData() {
    return apiInstance.get(`${GET_USER_DATA}`).json<UserData>()
}
